import { render, staticRenderFns } from "./InProgressDrafts.vue?vue&type=template&id=f299236a&"
import script from "./InProgressDrafts.vue?vue&type=script&lang=js&"
export * from "./InProgressDrafts.vue?vue&type=script&lang=js&"
import style0 from "./InProgressDrafts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports